/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { SmBadge, SmIcon } from '@smiles/smiles-react-design-system';

import useApi from '@/hooks/useApi';

import { Button } from '@/components/global/Button';

import { TComponentCard } from '@/services/requests/Recommendation/types/template5';
import { dispatchInteraction } from '@/services/requests/Interactions/helpers';
import { TInteractionClickComponent } from '@/services/requests/Interactions/types';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';

export const CardLogged = ({
  card: {
    type,
    theme,
    icon_title,
    title,
    tag_title,
    tag_title2,
    reusable_text,
    reusable_value,
    reusable_max_value,
    icon_text,
    text,
    cta,
    rules,
    voucher_number,
  },
  recommendationId,
  index,
}: {
  card: TComponentCard;
  recommendationId: string;
  index: number;
}) => {
  const percent =
    reusable_value && reusable_max_value && !isNaN(+reusable_value) && !isNaN(+reusable_max_value)
      ? (+reusable_value / +reusable_max_value) * 100
      : 0;

  const variant: 'club' | 'primary' =
    theme && theme === 'clube' ? 'club' : 'primary';

  const { Api, traceId } = useApi();

  const handleButtonClickInternal = async (link = '') => 
    {
    console.log('Button clicked with link:', link);
    dispatchInteraction<TInteractionClickComponent>(Api, 'click-component', {
      recommendationId,
      details: {
        recommendationId,
        voucherNumber: voucher_number,
        traceId,
      },
    });


    if (link === '/modal-rules') {
      const eventData = new CustomEvent('smls-b2c-modals-open', {
        detail: {
          recommendationId,
          voucherNumber: voucher_number,
          traceId,
          modal: 'rules',
        },
      });
      window.dispatchEvent(eventData);
      return;
    }

    if (link === '' || link === undefined || link === '/') {
      const eventData = new CustomEvent('smls-b2c-modals-open', {
        detail: {
          recommendationId,
          voucherNumber: voucher_number,
          traceId,
        },
      });
      window.dispatchEvent(eventData);
    } else {
      window.location.href = link;
    }
  };

  return (
    <div
      className="vitrine-template5__vouchers_carrousel__card"
      data-id={`${index}-${voucher_number}`}
    >
      <div className="vitrine-template5__vouchers_carrousel__card__top">
        <div className="icon">
          <img
            src={icon_title}
            alt={clearHtmlTags(title)}
          />
        </div>
        <span className="title">
          <span className="text">{title}</span>{' '}
          <div className="group-tags">
            {tag_title && <SmBadge text={tag_title} data-testid={`badge-${variant}-${tag_title}`} variant={variant} />}
            {tag_title2 && <SmBadge text={tag_title2} data-testid={`badge-${variant}`} variant={variant} />}
          </div>
        </span>
      </div>

      {type === '["reusable_voucher"]' &&
        reusable_value &&
        reusable_max_value && (
          <div className="vitrine-template5__vouchers_carrousel__card__middle">
            <div className="progress">
              <div data-testid="progress-bar" style={{ width: `${percent}%` }} />
            </div>
            <div className="text">
              <strong>{reusable_value}</strong> {reusable_text}{' '}
              <strong>{reusable_max_value}</strong> milhas
            </div>
          </div>
        )}

      <div className="vitrine-template5__vouchers_carrousel__card__bottom">
        <div className="icon">
          <SmIcon name={icon_text} size="medium" type="round" />
        </div>
        <span className="text">{text}</span>
        <div className="vitrine-template5__vouchers_carrousel__card__bottom--button">
          {rules?.label && (
            <Button
              text={rules.label}
              className="button-rules"
              isPill
              onClick={() => handleButtonClickInternal(rules?.link ?? '')}
            />
          )}

          {cta.label && (
            <Button
              text={cta.label}
              className="desktop-button"
              isPill
              onClick={() => handleButtonClickInternal(cta?.link ?? '')}
              variant={variant}
            />
          )}
        </div>
        <button
          type="button"
          className="mobile-button"
          data-testid="mobile-button"
          onClick={() => handleButtonClickInternal('')}
        >
          <SmIcon name="arrow_back_ios" size="small" />
        </button>
      </div>
    </div>
  );
};
